import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import './App.css';
import Moment from 'moment';
import GroupsMap from './GroupsMap'
import AppSettings from './App.json'

class Groups extends Component {

  constructor(props) {
    super(props)
    this.state = {
      groups: [],
      keyword: '',
      anyLifeStage: true,
      lifeStages: [],
      anyNeighborhood: true,
      neighborhoods: [],
      anyMeetingDay: true,
      meetingDays: [],
      anyMeetingTime: true,
      meetingTimes: [],
      meetInPerson: true,
      meetOnline: true,
      currentView: 1,
      advancedSearchHidden: true,
      accordionKeys: ['0','1'],
      toggleSpinner: false,
    }    
    console.log("Groups::constructor")
    this.AdvancedSearch = React.createRef()
    this.AdvancedSearchContent = React.createRef()
    this.KeywordSearch = React.createRef()
    this.LifeStagesAny = React.createRef()
    this.NeighborhoodsAny = React.createRef()
    this.MeetingDaysAny = React.createRef()
    this.MeetingTimesAny = React.createRef()
    this.ListView = React.createRef()
    this.MapView = React.createRef()
    this.Spinner = React.createRef()
  } 

  componentDidMount() {
    console.log('Groups::componentDidMount')
    this.LoadStateToLocalStorage()
    //this.GetLifeStages()
  }

  GroupClicked = (groupID) => {
    console.log("Groups::GroupClicked")
    this.SaveStateToLocalStorage()
    this.props.history.push('/SmallGroupWidget/groupdetail?g=' + groupID)
  }

  LoadStateToLocalStorage = () => {
    console.log("Groups::LoadStateToLocalStorage")
    this.setState({toggleSpinner: true})
    let smallGroupWidgetState = JSON.parse(window.sessionStorage.getItem('smallGroupWidgetState'))
    if (smallGroupWidgetState) {      
      // Life Stages
      const _lifeStages = []
      if (smallGroupWidgetState.lifeStages) {
        smallGroupWidgetState.lifeStages.forEach(record => {
          let _key = record[0]
          let _lifeStage = { lifeStageID: record[1].lifeStageID, lifeStage: record[1].lifeStage, _checked: record[1]._checked };        
          _lifeStages[_key] = _lifeStage
        })
      } else {
        this.GetLifeStages()
      }
      // Neighborhoods
      const _neighborhoods = []
      if (smallGroupWidgetState.neighborhoods) {
        smallGroupWidgetState.neighborhoods.forEach(record => {
          let _key = record[0]
          let _neighborhood =  {neighborhoodID: record[1].neighborhoodID, neighborhoodName: record[1].neighborhoodName, _checked: record[1]._checked, };     
          _neighborhoods[_key] = _neighborhood
        })
      } else {
        this.GetNeighborhoods()
      }
      // MeetingDays
      const _meetingDays = []
      if (smallGroupWidgetState.meetingDays) {
        smallGroupWidgetState.meetingDays.forEach(record => {
          let _key = record[0]
          let _meetingDay =  {meetingDayID: record[1].meetingDayID, meetingDay: record[1].meetingDay, _checked: record[1]._checked, }; 
          _meetingDays[_key] = _meetingDay
        })
      } else {
        this.GetMeetingDays()
      }
      // MeetingTimes
      const _meetingTimes = []
      if (smallGroupWidgetState.meetingTimes) {
        smallGroupWidgetState.meetingTimes.forEach(record => {
          let _key = record[0]
          let meetingTime =  {meetingTimeID: record[1].meetingTimeID, meetingTime: record[1].meetingTime, _checked: record[1]._checked, }
          _meetingTimes[_key] = meetingTime
        })
      } else {
        this.GetMeetingTimes()
      }
      if (smallGroupWidgetState.currentView) {
        this.setState({
          currentView: smallGroupWidgetState.currentView,
      },()=>{
        if (smallGroupWidgetState.currentView === 1) {
          this.ListView.current.className="viewToggleButtonFocused"
          this.MapView.current.className="viewToggleButton"
        } else {
          this.ListView.current.className="viewToggleButton"
          this.MapView.current.className="viewToggleButtonFocused"
        }
      })
      } else {
        this.setState({
          currentView: 1,
        },()=>{
          this.ListView.current.className="viewToggleButtonFocused"
          this.MapView.current.className="viewToggleButton"
        })
      }
      // Save State
      this.setState({
        advancedSearchHidden: (smallGroupWidgetState.advancedSearchHidden === false) ? false : true,
        keyword: (smallGroupWidgetState.keyword) ? smallGroupWidgetState.keyword : '',
        anyLifeStage: (smallGroupWidgetState.anyLifeStage === false) ? false : true,
        lifeStages: _lifeStages,
        anyNeighborhood: (smallGroupWidgetState.anyNeighborhood === false) ? false : true,
        neighborhoods: _neighborhoods,
        anyMeetingDay: (smallGroupWidgetState.anyMeetingDay === false) ? false : true,
        meetingDays: _meetingDays,
        anyMeetingTime: (smallGroupWidgetState.anyMeetingTime === false) ? false : true,
        meetingTimes: _meetingTimes,
        meetInPerson: (smallGroupWidgetState.meetInPerson === false) ? false : true,
        meetOnline: (smallGroupWidgetState.meetOnline === false) ? false : true,
      }, ()=> {
        this.SearchClicked()
      })
    // No State Save Load normal
    } else {
      this.GetLifeStages()
    }
  }

  SaveStateToLocalStorage = () => {
    console.log("Groups::SaveStateToLocalStorage")
    let smallGroupWidgetState = {
      advancedSearchHidden: this.state.advancedSearchHidden,
      keyword: this.state.keyword,
      anyLifeStage: this.state.anyLifeStage,
      lifeStages: Object.entries(this.state.lifeStages),
      anyNeighborhood: this.state.anyNeighborhood,
      neighborhoods: Object.entries(this.state.neighborhoods),
      anyMeetingDay: this.state.anyMeetingDay,
      meetingDays: Object.entries(this.state.meetingDays),
      anyMeetingTime: this.state.anyMeetingTime,
      meetingTimes: Object.entries(this.state.meetingTimes),
      meetInPerson: this.state.meetInPerson,
      meetOnline: this.state.meetOnline,
      currentView: this.state.currentView,
    }
    window.sessionStorage.setItem('smallGroupWidgetState', JSON.stringify(smallGroupWidgetState))
  }

  GetLifeStages = () => {
    console.log('Groups::GetLifeStages');
    //let _url = "https://localhost:44374/SmallGroupWidget/API/GetLifeStages"
    //let _url = "https://charliebrown.pointsnorthsys.com/SmallGroupWidgetWebAPI/API/GetLifeStages"
    this.setState({toggleSpinner: true})
    let _url = AppSettings.SERVER_URL + '/API/GetLifeStages'
    fetch(_url, {
        method: "GET",
      })
      .then(async response => {
        const data = await response.json(); 
        const _lifeStages = []
        data.LifeStages.forEach(record => {
            let _lifeStage = {lifeStageID: record.Life_Stage_ID, lifeStage: record.Life_Stage, _checked: false, };
            _lifeStages['lif'+_lifeStage.lifeStageID] = _lifeStage
        });
        this.setState({
          lifeStages: _lifeStages,
        }, ()=>{ 
          console.log(this.state.lifeStages) 
          this.GetNeighborhoods()
        });
      })
      .catch(error => {
        console.error('Groups::GetLifeStages: There was an error!', error);
    });
  };   

  GetNeighborhoods = () => {
    console.log('Groups::GetNeighborhoods');
    //let _url = "https://localhost:44374/SmallGroupWidget/API/GetNeighborhoods";
    //let _url = "https://charliebrown.pointsnorthsys.com/SmallGroupWidgetWebAPI/API/GetNeighborhoods";
    let _url = AppSettings.SERVER_URL + '/API/GetNeighborhoods'
    fetch(_url, {
        method: "GET",
      })
      .then(async response => {
        const data = await response.json(); 
        const _neighborhoods = []
        data.Neighborhoods.forEach(record => {
            let _neighborhood = {neighborhoodID: record.Neighborhood_ID, neighborhoodName: record.Neighborhood_Name, _checked: false, };
            _neighborhoods['nbh'+_neighborhood.neighborhoodID] = _neighborhood
        });
        this.setState({
          neighborhoods: _neighborhoods,
        }, this.GetMeetingDays);
      })
      .catch(error => {
        console.error('Groups::GetNeighborhoods: There was an error!', error);
    });
  };   

  GetMeetingDays = () => {
    console.log('Groups::GetMeetingDays');
    //let _url = "https://localhost:44374/SmallGroupWidget/API/GetMeetingDays";
    //let _url = "https://charliebrown.pointsnorthsys.com/SmallGroupWidgetWebAPI/API/GetMeetingDays";
    let _url = AppSettings.SERVER_URL + '/API/GetMeetingDays'
    fetch(_url, {
        method: "GET",
      })
      .then(async response => {
        const data = await response.json(); 
        const _meetingDays = []
        data.MeetingDays.forEach(record => {
            let _meetingDay = {meetingDayID: record.Meeting_Day_ID, meetingDay: record.Meeting_Day, _checked: false, };
            _meetingDays['mtd'+_meetingDay.meetingDayID] = _meetingDay
        });
        this.setState({
          meetingDays: _meetingDays,
        }, this.GetMeetingTimes);
      })
      .catch(error => {
        console.error('Groups::GetMeetingDays: There was an error!', error);
    });
  };   

  GetMeetingTimes = () => {
    console.log('Groups::GetMeetingTimes');
    let _meetingTimes = []
    _meetingTimes['mtm1'] = {meetingTimeID: 1, meetingTime: 'Morning', _checked: false, }
    _meetingTimes['mtm2'] = {meetingTimeID: 2, meetingTime: 'Afternoon', _checked: false, }
    _meetingTimes['mtm3'] = {meetingTimeID: 3, meetingTime: 'Evening', _checked: false, }
    this.setState({
      meetingTimes: _meetingTimes,
    }, ()=> {    
      this.SearchClicked()
    } );
  }

  GetGroups = (_keyword, _lifeStages, _neighborhoods, _meetingDays, _meetingTimes, _meetsInPerson, _meetsOnline) => {
    console.log('Groups::GetGroups');
    //let _url = "https://localhost:44374/SmallGroupWidget/API/GetGroups";
    //let _url = "https://charliebrown.pointsnorthsys.com/SmallGroupWidgetWebAPI/API/GetGroups";
    let _url = AppSettings.SERVER_URL + '/API/GetGroups'
    console.log(_url)
    let data = {keyword: _keyword, lifeStages: _lifeStages, neighborhoods: _neighborhoods, meetingDays: _meetingDays, meetingTimes: _meetingTimes, meetsInPerson: _meetsInPerson, meetsOnline: _meetsOnline};
    fetch(_url, {
        method: "POST",
        body: JSON.stringify(data), 
        headers: {
          'Accept': 'application/json, text/plain',
          'Content-Type': 'application/json;charset=UTF-8'
        },
      })
      .then(async response => {
        const data = await response.json(); 
        const _groups = []
        data.Groups.forEach(record => {
            let _group = {groupID: record.Group_ID, groupName: record.Group_Name, description: record.Description, meetingDay: record.Meeting_Day, meetingTime: record.Meeting_Time, meetsOnline: record.Meets_Online, nextMeetingDate: record.Next_Scheduled_Meeting, address1: record.Address_Line_1, address2: record.Address_Line_2, city: record.City, state: record.State_Region, zip: record.Postal_Code, lifeStage: record.Life_Stage, latitude: record.Latitude, longitude: record.Longitude };
            _groups.push(_group)
        });
        this.setState({
          groups: _groups,
          toggleSpinner: false,
        });
      })
      .catch(error => {
        console.error('Groups::GetGroups: There was an error!', error);
    });
  };   
    
  ReturnLocation = (city, state, zip) => {
    let x=''
    if (city) {
      x += city + ', ' + state + ' ' + zip
    }
    return (<div><span className='groupLabel'>Location:&nbsp;</span><span className='groupData'>{x}</span></div>);
  }
  
  ReturnMeetingTime = (meetingDay, meetingTime) => {
    let x=''
    if (meetingDay) {
      var dt = new Date('01/01/1970 ' + meetingTime);
      x += meetingDay + 's @ ' + Moment(dt).format('h:mm A')
    }
    return (<div><span className='groupLabel'>Meeting Day:&nbsp;</span><span className='groupData'>{x}</span></div>);
  }
  
  ReturnNextMeetingTime = (nextMeetingDate) => {
    let x=''
    if (nextMeetingDate) {
      var dt = new Date(nextMeetingDate);
      x += Moment(dt).format('MMMM D, yyyy') //Moment(dt).format('M/D/yyyy')
    }
    return (<div><span className='groupLabel'>Next Meeting:&nbsp;</span><span className='groupData'>{x}</span></div>);
  }

  ReturnNextMeetingFormat = (meetsOnline) => {
    let x=(meetsOnline) ? "Meets Online" : "Meets In-Person"
    return (<div><span className='groupLabel'>Format:&nbsp;</span><span className='groupData'>{x}</span></div>);
  }

  ReturnLifeStage = (lifeStage) => {
    let x=''
    if (lifeStage) {
      x += lifeStage
    }
    return (<div><span className='groupLabel'>Life Stage:&nbsp;</span><span className='groupData'>{x}</span></div>);
  }

  ReturnDescription = (description) => {
    return (<div className='groupData'>{description}</div>);
  }

  OnChangedCheckbox = (event) => {
    let _typ = event.target.id.substring(0,3)
    let _key = event.target.id
    if (_typ === 'lif') {
      this.LifeStagesAny.current.checked = false
      let _items = this.state.lifeStages;
      _items[_key]._checked = event.target.checked
      this.setState({ lifeStages: _items })
    }
    if (_typ === 'nbh') {
      this.NeighborhoodsAny.current.checked = false
      let _items = this.state.neighborhoods;
      _items[_key]._checked = event.target.checked
      this.setState({ neighborhoods: _items })
    }
    if (_typ === 'mtd') {
      this.MeetingDaysAny.current.checked = false
      let _items = this.state.meetingDays;
      _items[_key]._checked = event.target.checked
      this.setState({ meetingDays: _items })
    }
    if (_typ === 'mtm') {
      this.MeetingTimesAny.current.checked = false
      let _items = this.state.meetingTimes;
      _items[_key]._checked = event.target.checked
      this.setState({ meetingTimes: _items })
    }
    if (_key === 'onl1') {
      this.setState({ meetInPerson: event.target.checked })
    }
    if (_key === 'onl2') {
      this.setState({ meetOnline: event.target.checked })
    }
  }

  ResetClicked = () => {
    console.log('Groups::ResetClicked')
    window.sessionStorage.removeItem('smallGroupWidgetState')
    //this.LoadStateToLocalStorage()
    this.setState({
      groups: [],
      keyword: '',
      anyLifeStage: true,
      lifeStages: [],
      anyNeighborhood: true,
      neighborhoods: [],
      anyMeetingDay: true,
      meetingDays: [],
      anyMeetingTime: true,
      meetingTimes: [],
      meetInPerson: true,
      meetOnline: true,
      currentView: 1,
      advancedSearchHidden: true,
      accordionKeys: ['0','1'],
    }, ()=> {
      this.LoadStateToLocalStorage()
    })

    //window.location.reload(false);
  }

  SearchClicked = () => {
    console.log("Groups::SearchClicked");
    let _keyword = this.state.keyword
    let _lifeStages = []
    let _neighborhoods = []
    let _meetingDays = []
    let _meetingTimes = []
    if (this.LifeStagesAny.current.checked) {
      _lifeStages.push({lifeStageID: 0, lifeStage: '', _checked: true, })
    } else {
      Object.entries(this.state.lifeStages).map(([key, value]) => (_lifeStages.push(value)))
    }
    if (this.NeighborhoodsAny.current.checked) {
      _neighborhoods.push({neighborhoodID: 0, neighborhoodName: '', _checked: true, })
    } else {
      Object.entries(this.state.neighborhoods).map(([key, value]) => (_neighborhoods.push(value)))
    }
    if (this.MeetingDaysAny.current.checked) {
      _meetingDays.push({meetingDayID: 0, meetingDay: '', _checked: true, })
    } else {
      Object.entries(this.state.meetingDays).map(([key, value]) => (_meetingDays.push(value)))
    }
    if (this.MeetingTimesAny.current.checked) {
      _meetingTimes.push({meetingTimeID: 0, meetingTime: '', _checked: true, })
    } else {
      Object.entries(this.state.meetingTimes).map(([key, value]) => (_meetingTimes.push(value)))
    }
    this.GetGroups(_keyword, _lifeStages, _neighborhoods, _meetingDays, _meetingTimes, this.state.meetInPerson, this.state.meetOnline);
  }

  NeedMoreHelpClicked = () => {
    console.log("Groups::NeedMoreHelpClicked");
    this.props.history.push('/SmallGroupWidget/needmorehelp')
  }

  ShowList = () => {
    this.setState({
      currentView: 1,
    }, () => {
      this.ListView.current.className="viewToggleButtonFocused"
      this.MapView.current.className="viewToggleButton"
      this.SaveStateToLocalStorage()
    })
  }

  ShowMap = () => {
    this.setState({
      currentView: 2,
    }, ()=>{
      this.ListView.current.className="viewToggleButton"
      this.MapView.current.className="viewToggleButtonFocused"
      this.SaveStateToLocalStorage()
    })
  }

  SelectAny = (_typ, _checked) => {
    if (_typ === 'lif') {
      //const _items = this.state.lifeStages;
      //Object.entries(_items).map(([key, value]) => (value._checked = !_checked))
      this.setState({
        anyLifeStage: _checked,
        //lifeStages: _items
      })
    }
    if (_typ === 'nbh') {
      //const _items = this.state.neighborhoods;
      //Object.entries(_items).map(([key, value]) => (value._checked = !_checked))
      this.setState({
        anyNeighborhood: _checked,
        //neighborhoods: _items
      })
    }
    if (_typ === 'mtd') {
      //const _items = this.state.meetingDays;
      //Object.entries(_items).map(([key, value]) => (value._checked = !_checked))
      this.setState({
        anyMeetingDay: _checked,
        //meetingDays: _items
      })
    }
    if (_typ === 'mtm') {
      //const _items = this.state.meetingTimes;
      //Object.entries(_items).map(([key, value]) => (value._checked = !_checked))
      this.setState({
        anyMeetingTime: _checked,
        //meetingTimes: _items
      })
    }
  }

  KeywordOnKeyUp = (e) => {
    if (e.key === 'Enter') {
      this.SearchClicked()
    }
  }

  KeywordOnChange = (e) => {
    this.setState({
      keyword: e.target.value,
    })
  }

  AdvancedSearchClicked = () => {
    console.log("Groups::AdvancedSearchClicked")
    this.setState({
      advancedSearchHidden: !this.state.advancedSearchHidden,
    }, ()=>{
      this.AdvancedSearch.current.hidden = this.state.advancedSearchHidden;
    })    
  }

  render() {    
    return (
      <div className="outerDiv">
        <div className='filterDiv'>
          <div className='accordionDivOuter'>
            <div className='accordionDivSection'>
              <div className="accordionSectionTitle">
                Search
              </div>
              <div className="accordionSectionContent">
                  <span className='formFieldLabel'>Keyword Search</span>
                  <div className='filterKeywordDiv'>
                    <input className='form-control' value={this.state.keyword} placeholder={'Keyword'} onChange={(e)=>this.KeywordOnChange(e)} onKeyUp={(e)=>this.KeywordOnKeyUp(e)} ></input>
                  </div>
              </div>
            </div>
            <div className='accordionDivSection'>
              <button type={'button'} className='accordionSectionTitleClickable' onClick={()=>this.AdvancedSearchClicked()}><span className='accordionSectionTitleText'>Advanced Search</span><span hidden={!this.state.advancedSearchHidden} className='accordionSectionTitleClickableInstr'>(click to open)</span><span className='accordionSectionTitleIcon'>&#65085;</span></button>
              <div ref={this.AdvancedSearch} className="accordionSectionContent" hidden={this.state.advancedSearchHidden}>
                <div ref={this.AdvancedSearchContent}>
              <span className='formFieldLabel'>Life Stages</span> 
                <div className='filterCheckboxDiv'>
                    <div className="filterCheckboxItem">
                      <span className='filterCheckBoxLabel'>-Any-</span>
                      <input ref={this.LifeStagesAny} checked={this.state.anyLifeStage} className='filterCheckBox' type={'checkbox'} onChange={()=>this.SelectAny('lif', this.LifeStagesAny.current.checked)}></input>
                    </div>
                    {
                      Object.entries(this.state.lifeStages).map(([key, value]) => (
                        <div className="filterCheckboxItem" key={key}>
                          <span className='filterCheckBoxLabel'>{value.lifeStage}</span>
                          <input id={key} checked={this.state.lifeStages[key]._checked} className='filterCheckBox' type={'checkbox'} onChange={this.OnChangedCheckbox}></input>
                        </div>
                      ))
                    }
                </div>
                <span className='formFieldLabel'>Neighborhoods</span>
                <div className='filterCheckboxDiv'>
                    <div className="filterCheckboxItem">
                      <span className='filterCheckBoxLabel'>-Any-</span>
                      <input ref={this.NeighborhoodsAny} checked={this.state.anyNeighborhood} className='filterCheckBox' type={'checkbox'} onChange={()=>this.SelectAny('nbh', this.NeighborhoodsAny.current.checked)}></input>
                    </div>
                    {
                      Object.entries(this.state.neighborhoods).map(([key, value]) => (
                        <div className="filterCheckboxItem" key={key}>
                          <span className='filterCheckBoxLabel'>{value.neighborhoodName}</span>
                          <input id={key} checked={this.state.neighborhoods[key]._checked} className='filterCheckBox' type={'checkbox'} onChange={this.OnChangedCheckbox}></input>
                        </div>
                      ))
                    }
                </div>
                <span className='formFieldLabel'>Meeting Days</span>
                <div className='filterCheckboxDiv'>
                    <div className="filterCheckboxItem" key={'meetingDayAny'}>
                      <span className='filterCheckBoxLabel'>-Any-</span>
                      <input ref={this.MeetingDaysAny} checked={this.state.anyMeetingDay} className='filterCheckBox' type={'checkbox'} onChange={()=>this.SelectAny('mtd', this.MeetingDaysAny.current.checked)}></input>
                    </div>
                    {
                      Object.entries(this.state.meetingDays).map(([key, value]) => (
                        <div className="filterCheckboxItem" key={key}>
                          <span className='filterCheckBoxLabel'>{value.meetingDay}</span>
                          <input id={key} checked={this.state.meetingDays[key]._checked} className='filterCheckBox' type={'checkbox'} onChange={this.OnChangedCheckbox}></input>
                        </div>
                      ))
                    }
                </div>
                <span className='formFieldLabel'>Meeting Times</span>
                <div className='filterCheckboxDiv'>
                    <div className="filterCheckboxItem" key={'meetingTimeAny'}>
                      <span className='filterCheckBoxLabel'>-Any-</span>
                      <input ref={this.MeetingTimesAny} checked={this.state.anyMeetingTime} className='filterCheckBox' type={'checkbox'} onChange={()=>this.SelectAny('mtm', this.MeetingTimesAny.current.checked)}></input>
                    </div>
                    {
                      Object.entries(this.state.meetingTimes).map(([key, value]) => (
                        <div className="filterCheckboxItem" key={key}>
                          <span className='filterCheckBoxLabel'>{value.meetingTime}</span>
                          <input id={key} checked={this.state.meetingTimes[key]._checked} className='filterCheckBox' type={'checkbox'} onChange={this.OnChangedCheckbox}></input>
                        </div>
                      ))
                    }
                </div>
                <span className='formFieldLabel'>Meeting Format</span>
                <div className='filterCheckboxDiv'>                
                    <div className="filterCheckboxItem" key={'onl1'}>
                      <span className='filterCheckBoxLabel'>In-Person</span>
                      <input id={'onl1'} checked={this.state.meetInPerson} className='filterCheckBox' type={'checkbox'} onChange={this.OnChangedCheckbox}></input>
                    </div>                 
                    <div className="filterCheckboxItem" key={'onl2'}>
                      <span className='filterCheckBoxLabel'>Online</span>
                      <input id={'onl2'} checked={this.state.meetOnline} className='filterCheckBox' type={'checkbox'} onChange={this.OnChangedCheckbox}></input>
                    </div>                 
                </div>
                </div>
              </div>
            </div>



          </div>
            <div className="searchButtonDiv">
              <button className='searchButton' onClick={()=>this.SearchClicked()}>Search Groups</button>
              <button className='resetButton' onClick={()=>this.ResetClicked()}>Reset Filter</button>
            </div>     
            <div className="searchButtonDiv">
              <button className='needMoreHelpLink' onClick={()=>{this.NeedMoreHelpClicked()}}>Help, I still can't find a group!</button>  
            </div>
        </div>
        <div className='viewToggleDiv'>
          <button className='viewToggleButton' onClick={this.ShowList} ref={this.ListView}>List View</button>
          <button className='viewToggleButton' onClick={this.ShowMap} ref={this.MapView} hidden>Map View</button>
        </div>
        <div className='groupsDiv' hidden={(this.state.currentView === 1) ? false : true}>
          <div className="row">		  
            { 
              this.state.groups.map(group => (
                <div className="col-lg-4 col-xs-12 col-sm-6 col-md-6" key={'grp'+group.groupID}>
                  <div className="groupDiv">
                    <div className="groupNameDiv">{group.groupName}</div>                
                    <div className="groupLocationDiv">{this.ReturnLocation(group.city, group.state, group.zip)}</div>                  
                    <div className="groupMeetingTimeDiv">{this.ReturnMeetingTime(group.meetingDay,group.meetingTime)}</div>                  
                    <div className="groupMeetingTimeDiv">{this.ReturnNextMeetingFormat(group.meetsOnline)}</div>                  
                    <div className="groupNextMeetingDiv">{this.ReturnNextMeetingTime(group.nextMeetingDate)}</div>     
                    <div className="groupNextMeetingDiv">{this.ReturnLifeStage(group.lifeStage)}</div>     
                    <div className="groupDescriptionDiv">{this.ReturnDescription(group.description)}</div>     
                    <div className="detailsButtonDiv"><button className='detailsButton' onClick={()=>this.GroupClicked(group.groupID, group.groupName)}>Details</button></div>     
                  </div>        
                </div>
              ))
            }
          </div>
          <div className="needMoreHelpDiv">
              <br />
              <button className='needMoreHelpLink' onClick={()=>{this.NeedMoreHelpClicked()}}>Help, I still can't find a group!</button>  
          </div>
        </div>    
        <div className='groupsDiv' hidden={(this.state.currentView === 2) ? false : true}>
          <GroupsMap groups={this.state.groups} />
          <div className="needMoreHelpDiv">
              <br />
              <button className='needMoreHelpLink' onClick={()=>{this.NeedMoreHelpClicked()}}>Help, I still can't find a group!</button>  
          </div>
        </div>
        {(this.state.toggleSpinner) && (
        <div className='spinnerDiv'>
          <div className='spinnerContent'>
            Loading...
          </div>
        </div>
        )}
      </div>
    )   
  }
}

export default withRouter(Groups)